import React, { useEffect, useState } from "react"
import { Link as RouterLink } from "react-router-dom"
import { providerFinderRootPath } from "../../utils/providerFinderSearchUrl"
import { getHeap } from "../../utils/heap"
import { defineMessage, FormattedMessage } from "react-intl"
import { Box, Button, Link, Typography } from "@carrotfertility/carotene-core"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { RecommendDoulaDialog } from "#/pages/provider-finder/recommend-doula/RecommendDoulaDialog"
import { NoResultLayout } from "./NoResultLayout"

export function DoulaNoResultDisplay({ isCountryCodeMatching }: { isCountryCodeMatching: boolean }): JSX.Element {
  const { mutate: trackMemberAction } = useMemberActionTracking()
  const [openRecommendDoulaDialog, setOpenRecommendDoulaDialog] = useState(false)

  useEffect(
    function trackDoulaSearchNoResultsMessageRendered() {
      getHeap().track("Doula Search No Results Message Rendered", {
        "Location Is Outside Country": !isCountryCodeMatching ? "true" : "false"
      })
    },
    [isCountryCodeMatching]
  )

  const headerMessage = defineMessage({ defaultMessage: "No results in Provider finder, but..." })

  return (
    <>
      <NoResultLayout
        header={
          <Typography variant="h4" color="secondary">
            <FormattedMessage {...headerMessage} />
          </Typography>
        }
        body={
          <Typography variant="body1" color="secondary">
            <FormattedMessage defaultMessage="We add new providers all the time. You can recommend a doula to help us grow our network." />
          </Typography>
        }
        actions={
          <Box display="flex" gap={(theme) => theme.tokens.spacing.xs}>
            <Button
              component={RouterLink}
              to={providerFinderRootPath}
              variant="outlined"
              color="secondary"
              size="medium"
            >
              <FormattedMessage defaultMessage="Search again" />
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                setOpenRecommendDoulaDialog(true)
                trackMemberAction({
                  memberActionTaken: MemberActions.PROVIDER_FINDER_RECOMMEND_A_DOULA_OPENED,
                  metaData: {
                    location: `Provider Finder Doula No Results Display`
                  }
                })
              }}
            >
              <FormattedMessage defaultMessage="Recommend a doula" />
            </Button>
          </Box>
        }
        footer={
          <Typography variant="body1" color="secondary" textAlign="center">
            <FormattedMessage
              defaultMessage="Still having trouble? <Link>Contact us</Link>."
              values={{
                Link: (textLinkContent) => (
                  <Link component={RouterLink} color="inherit" to="/talk-to-carrot/sendmessage/helpfindingdoula">
                    {textLinkContent}
                  </Link>
                )
              }}
            />
          </Typography>
        }
      />
      <RecommendDoulaDialog open={openRecommendDoulaDialog} onClose={() => setOpenRecommendDoulaDialog(false)} />
    </>
  )
}
